// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/operacional/services/requisicaoService.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import { paramsDaLista, type ListaFiltros, type PaginadoComResumo, type RequisicaoListaResumo } from './listaFiltros';
import type {
  RequisicaoResumo,
  RequisicaoDetalhe,
  CriarRequisicaoRequest,
  AtualizarRequisicaoRequest,
} from '../types';

const BASE = '/api/requisicoes';

export const requisicaoService = {
  async getAll(pagina = 1, tamanhoPagina = 20, filtros: ListaFiltros = {}): Promise<PaginadoComResumo<RequisicaoResumo, RequisicaoListaResumo>> {
    const { data } = await apiClient.get<PaginadoComResumo<RequisicaoResumo, RequisicaoListaResumo>>(BASE, {
      params: paramsDaLista(pagina, tamanhoPagina, filtros),
    });
    return data;
  },

  async getPendentes(): Promise<RequisicaoResumo[]> {
    const { data } = await apiClient.get<RequisicaoResumo[]>(`${BASE}/pendentes`);
    return data;
  },

  async getById(id: number): Promise<RequisicaoDetalhe> {
    const { data } = await apiClient.get<RequisicaoDetalhe>(`${BASE}/${id}`);
    return data;
  },

  async create(request: CriarRequisicaoRequest): Promise<RequisicaoDetalhe> {
    const { data } = await apiClient.post<RequisicaoDetalhe>(BASE, request);
    return data;
  },

  async update(id: number, request: AtualizarRequisicaoRequest): Promise<RequisicaoResumo> {
    const { data } = await apiClient.put<RequisicaoResumo>(`${BASE}/${id}`, request);
    return data;
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`${BASE}/${id}`);
  },
};
